import { useLocation, useNavigate } from 'react-router-dom'

import { Box, Tabs } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'
import i18n from 'modules/core/lib/i18n'

import { usePermissionGroup } from 'modules/permissions/hooks/usePermissionGroup'
import { PERMISSION_GROUP_KIND_ONBOARDING } from 'modules/permissions/lib/constants'

export const PermissionGroupsLayout = () => {
  const navigate = useNavigate()
  const { id } = useStrictParams<'id'>()
  const { pathname } = useLocation()
  const { navigation } = useNavigation()

  // FIXME: This should be a prop coming from the page
  const { permissionGroup } = usePermissionGroup({ id: Number(id) })
  if (!permissionGroup) {
    return null
  }

  const tabs = [
    {
      label: i18n.t('settings.permissions.group.permissions'),
      href: navigation.settings.permissions.id.fullPath({ id: permissionGroup.id }),
    },
  ]

  if (permissionGroup.kind === PERMISSION_GROUP_KIND_ONBOARDING) {
    return (
      <Box paddingBottom="s24">
        <Tabs currentId={pathname} onTabClicked={(tabId) => navigate(tabId)} hasAdditionalPadding>
          <Tabs.Tab
            key={navigation.settings.permissions.id.fullPath({ id: permissionGroup.id })}
            id={navigation.settings.permissions.id.fullPath({ id: permissionGroup.id })}
            label={i18n.t('settings.permissions.group.permissions')}
          />
        </Tabs>
      </Box>
    )
  }

  // Trying to configure the default basics group to be able to configure permissions for everyone
  // in the company is almost certainly a mistake, so let's not allow it at all.
  const isBasics = permissionGroup.defaultGroup && !permissionGroup.legacyAdmin
  if (!isBasics) {
    tabs.push({
      label: i18n.t('settings.permissions.group.permissions_delegate.title'),
      href: navigation.settings.permissions.id.delegate.fullPath({ id: permissionGroup.id }),
    })
  }

  tabs.push({
    label: i18n.t('settings.permissions.group.employees'),
    href: navigation.settings.permissions.id.employees.fullPath({ id: permissionGroup.id }),
  })

  tabs.push({
    label: i18n.t('settings.permissions.group.externals'),
    href: navigation.settings.permissions.id.externals.fullPath({ id: permissionGroup.id }),
  })

  if (!permissionGroup.legacyAdmin) {
    tabs.push({
      label: i18n.t('settings.permissions.visibility.title'),
      href: navigation.settings.permissions.id.visibility.fullPath({ id: permissionGroup.id }),
    })
  }

  return (
    <Box paddingBottom="s24">
      <Tabs currentId={pathname} onTabClicked={(tabId) => navigate(tabId)} hasAdditionalPadding>
        {tabs.map((tab) => (
          <Tabs.Tab key={tab.href} id={tab.href} label={tab.label} />
        ))}
      </Tabs>
    </Box>
  )
}
